import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  card: {
    color: TextColors.light,

    '& $contentCategory, $logoHeading': {
      color: SecondaryColors.main,
    },
    '& $contentHeading, $customerNameTitle': {
      color: TextColors.light,
    },
    '& $copy': {
      color: hexToRGBA(TextColors.light, TextOpacities.light2),
    },
  },
};

const lightTheme = {
  card: {
    color: TextColors.dark,

    '& $contentCategory, $logoHeading': {
      color: SecondaryColors.dark,
    },
    '& $contentHeading, $customerNameTitle': {
      color: TextColors.dark,
    },
    '& $copy': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light2),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    actions: {
      display: 'flex',
      flexFlow: 'column nowrap',
      justifyContent: 'space-between',
      alignContent: 'flex-start',
      alignItems: 'flex-start',
      padding: 0,

      '&.MuiCardActions-spacing > :not(:first-child)': {
        marginLeft: 0,
      },

      [muiTheme.breakpoints.up('md')]: {
        flexFlow: 'row nowrap',
        alignContent: 'flex-start',
        alignItems: 'flex-start',

        '& > *:not(:last-child)': {
          marginRight: muiTheme.spacing(2),
        },
      },
    },
    avatar: {
      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(1),
      },
    },
    bottom: {
      '&:not(:first-child)': {
        marginTop: muiTheme.spacing(4),
      },
    },
    carousel: {
      height: '100%',
    },

    cardLogo: {
      maxHeight: '65px',

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& img': {
        height: '100%',
        maxHeight: '65px',
        width: 'auto !important',
      },
    },

    content: {
      padding: 0,

      '&:last-child': {
        padding: 0,
      },
    },

    contentCategory: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },

    contentHeading: {
      transition: 'opacity 50ms ease-in, visibility 50ms ease-in',

      '&.MuiTypography-root': {
        [muiTheme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },

      '& + *': {
        marginTop: muiTheme.spacing(2),
      },
    },

    copy: {
      ...muiTheme.typography.body1,
    },

    currentCardCta: {
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        width: 'auto',
        marginTop: '5px',
      },
    },

    customerNameTitle: {
      marginBottom: muiTheme.spacing(2.25),

      '& .name': {
        ...muiTheme.typography.button,
        margin: '0 0 4px 0',
      },

      '& .title': {
        ...muiTheme.typography.caption,
        marginTop: `${muiTheme.spacing(0.5)}px`,
      },

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: 0,
      },

      '& > *': {
        margin: 0,
      },
    },

    image: {
      '&': {
        transition: 'opacity 50ms ease-in, visibility 50ms ease-in, position 50ms ease-in',
        paddingTop: '56.25%',
        marginBottom: muiTheme.spacing(2.5),
        padding: 0,
      },
    },

    logoHeading: {
      marginBottom: muiTheme.spacing(2),
      display: 'block',
    },

    root: {
      '&.dark-theme': darkTheme.card,
      '&.light-theme': lightTheme.card,
      boxShadow: muiTheme.shadows[8],
      borderRadius: '4px',
      maxWidth: '542px',
      width: '100%',
      flexShrink: 0,
    },

    container: {
      position: 'relative',
      padding: muiTheme.spacing(4),

      [muiTheme.breakpoints.up('md')]: {
        padding: muiTheme.spacing(10, 12),
      },
    },

    superHeading: {
      ...muiTheme.typography.overline,
      color: muiTheme.palette.secondary.main,
      marginBottom: muiTheme.spacing(2.5),
    },
    top: {
      flexGrow: 1,
      padding: 0,
    },
    wrapper: {
      position: 'relative',
      width: '100%',
    },
    cardLink: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 1,
      top: 0,
      left: 0,
    },
  }),
  { name: 'GenCardCarouselContentCard' },
);

export default useStyles;
